import React, { Component } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

class WebsiteNavbar extends Component {
  render() {
    return (
      <Navbar bg="light" expand="md">
        <Navbar.Brand href="/" to="/">
          Podstawy-CPP
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            <Nav.Link componentClass={Link} href="/" to="/">
              Strona Główna
            </Nav.Link>
            <Nav.Link
              componentClass={Link}
              href="/wprowadzenie"
              to="/wprowadzenie"
            >
              Rozpocznij Naukę
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default WebsiteNavbar;
